module.exports = __webpack_public_path__ + "img/navigation_yywl1.ffa4fe46.png";